import React from 'react';
import 'swiper/css';
import { Swiper, SwiperSlide, type SwiperRef } from 'swiper/react';

import { UiTypography } from '@/components/ui/Typography';
import { LAYOUT_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';

import { reviewsList, reviewsListWithoutDialogue } from './constants';
import { ReviewCardsStyles } from './ReviewCards.styles';

export const ReviewCards: React.FC<{
  color?: 'dark-violet' | 'domination';
  reverseList?: boolean;
}> = ({ color, reverseList }) => {
  const swiperRef = React.useRef<SwiperRef | null>(null);
  const layoutNotes = webCampaign.getLayoutNotes();
  const removeDialogueReferences = layoutNotes.includes(
    LAYOUT_NOTES.REMOVE_DIALOGUE_REFERENCES,
  );

  React.useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.swiper.update();
    }
  }, []);

  const selectedReviewsList = removeDialogueReferences
    ? reviewsListWithoutDialogue
    : reviewsList;

  const reviewsListAll = reverseList
    ? selectedReviewsList.reverse()
    : selectedReviewsList;

  return (
    <ReviewCardsStyles color={color}>
      <Swiper
        slidesPerView="auto"
        spaceBetween={12}
        className="review-cards-swiper"
        initialSlide={1}
        centeredSlides
        loop
        ref={swiperRef}
      >
        {reviewsListAll.map((review) => (
          <SwiperSlide className="review-card" key={review.author}>
            <div className="review-card-content">
              <div className="stars">
                <img src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg" />
                <img src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg" />
                <img src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg" />
                <img src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg" />
                <img src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg" />
              </div>
              <UiTypography className="text" variant="body-medium">
                {review.text}
              </UiTypography>
              <UiTypography
                className="author"
                variant="body-medium"
                color="neutral-black"
              >
                {review.author}
              </UiTypography>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </ReviewCardsStyles>
  );
};
